/**
 * AgentMarketingPanel — marketing-agent tab of the Lead Agent Workspace.
 * Wraps the existing enrichment UI (LeadIntelligencePanel) and previews the
 * future agent deliverables that will replace the raw Web Traffic tab.
 */

import React from 'react';
import type { Lead } from '../../types';
import { LeadIntelligencePanel } from '../deals/LeadIntelligencePanel';
import LeadWebTraffic from './LeadWebTraffic';
import InquireProjectInfo from './InquireProjectInfo';
import { Radar } from 'lucide-react';

interface AgentMarketingPanelProps {
  lead: Lead;
}

export const AgentMarketingPanel: React.FC<AgentMarketingPanelProps> = ({ lead }) => {
  return (
    <div className="amp-root">
      <InquireProjectInfo lead={lead} />
      <LeadIntelligencePanel lead={lead} />
      <LeadWebTraffic lead={lead} />
      <div className="amp-future">
        <div className="amp-future-row">
          <Radar size={15} className="amp-future-icon" />
          <span className="amp-future-titles">
            <span className="amp-future-title">Opportunity radar</span>
            <span className="amp-future-desc">Competitive signals and outreach timing hooks</span>
          </span>
          <span className="amp-soon-tag">Soon</span>
        </div>
      </div>
    </div>
  );
};
export default AgentMarketingPanel;
